module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Socket-us-6d24490a071ddf26f04f6ab0bfee79ac.svg";